import React from "react";

import { Container } from "react-bootstrap";

import PressComponent from "@/components/mediaCoverage/Press.component";
import TvComponent from "@/components/mediaCoverage/Tv.component";

import BannerComponent from "../components/Banner.component";
import DocumentComponent from "../components/Document.component";
import ScheduleComponent from "../components/Schedule.component";
import i18n from "../i18n";

const MediaCoverage = () => {
  const { t } = i18n;

  return (
    <React.Fragment>
      <DocumentComponent title={t("media_coverage")} />

      <BannerComponent description="" title={t("media_coverage")} />

      <TvComponent />

      <Container className="mb-4">
        <hr />
      </Container>

      <PressComponent />

      <ScheduleComponent />

      <br />
      <br />
      <br />
    </React.Fragment>
  );
};

export default MediaCoverage;
